import { api } from '@api/index'
import MessageModal from '@components/shared/MessageModal'
import useModal from '@hooks/useModal'
import { Message } from '@utils/message'
import { RegExps } from '@utils/regexps'
import React, { useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { useMutation } from 'react-query'
import { Link } from 'react-router-dom'
import 'twin.macro'

const FindId = () => {
  const [findedId, setFindedId] = useState<string | null>(null)
  const [openModal] = useModal()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({ mode: 'onChange' })

  const findIdMutation = useMutation(({ name, email }: FieldValues) =>
    api.userService.findId(name, email)
  )

  const handleFindId = (formData: FieldValues) => {
    findIdMutation.mutate(formData, {
      onError: (err) => {
        openModal(<MessageModal errorData={err} />)
      },
      onSuccess: (findedid) => {
        setFindedId(findedid)
      },
    })
  }

  if (findedId) {
    return (
      <section className="w-500">
        <div className="mb-3 text-2xl font-bold flex-center">아이디 찾기</div>
        <div className="mb-5 text-sm font-bold text-neutral-500 flex-center">
          등록된 회원정보와 일치하는 내용의 아이디입니다.
        </div>
        <div className="p-20 text-base font-bold flex-center">{findedId}</div>
        <div tw="w-full flex-center mt-6 mb-6 gap-28">
          <Link tw="w-250" to="/">
            <button tw="w-full" className="button base">
              로그인하기
            </button>
          </Link>
        </div>
      </section>
    )
  }

  return (
    <>
      <section className="w-500">
        <form onSubmit={handleSubmit(handleFindId)}>
          <div className="mb-3 text-2xl font-bold flex-center">아이디 찾기</div>
          <div className="mb-5 text-sm font-bold text-neutral-500 flex-center">
            등록된 회원정보와 같아야 조회가 가능합니다.
          </div>
          <div className="flex flex-col w-full gap-12 mb-3">
            <label>이름</label>
            <input
              {...register('name', {
                required: Message.valid.REQUIRE_NAME,
                pattern: {
                  value: RegExps.user.NAME,
                  message: Message.valid.INVALID_NAME,
                },
              })}
              tw="h-40"
              type="text"
              className="input"
              placeholder="이름을 입력해 주세요."
            />
            <div className="flex items-center h-10 py-1 text-base text-red-500">
              {errors.name && errors.name.message}
            </div>
            <label>이메일 주소</label>
            <input
              {...register('email', {
                required: Message.valid.REQUIRE_EMAIL,
                pattern: {
                  value: RegExps.user.EMAIL,
                  message: Message.valid.INVALID_EMAIL,
                },
              })}
              tw="h-40"
              type="text"
              className="input"
              placeholder="이메일 주소를 입력해 주세요."
            />
            <div className="flex items-center h-10 py-1 text-base text-red-500 ">
              {errors.email && errors.email.message}
            </div>
          </div>
          <div tw="w-full flex mt-18 mb-9 gap-28">
            <Link tw="w-full" to="/">
              <button type="button" tw="w-full" className="button base">
                취소
              </button>
            </Link>
            <button type="submit" tw="w-full" className="button base">
              다음
            </button>
          </div>
        </form>
      </section>
    </>
  )
}

export default FindId
